export default "__VITE_ASSET__jacixn10__"